// TODO: check if we can use following getEnumKeysAsArray function instead.
// TODO: BETTER. THIS IS LEGACY, USE `getValidEnumValues` NEW FUNCTION BELOW
export const getEnumValuesAsArray = (en) => {
    return (Object.keys(en)
        //.map((key) => Number(key))
        .map(Number)
        .filter((key) => !Number.isNaN(key)));
};
// // TODO: check my own variant, mb it is better?
// export const getOneOfType = (en: object) => {
// 	return Object.values(en).filter((value) => typeof value === 'number');
// };
/**
 * Returns an array of valid numeric values for Yup validation.
 * @param enumObject - The TypeScript enum or 'as const' object.
 * @param includeUnknown - Whether to allow the default "unknown" value (defaults to false).
 * @param unknownValue - The specific value treated as unknown (defaults to 0).
 */
export const getValidEnumValues = (enumObject, includeUnknown = false, unknownValue = 0) => {
    return Object.values(enumObject)
        .filter((value) => typeof value === 'number')
        .filter((value) => includeUnknown || value !== unknownValue);
};
/**
 * Gets a keys of the specified enum.
 * @param en - enum to extract keys
 * @returns An array with keys (names).
 * @example
 * {getEnumKeysAsArray(TransferProtocol).map((key) => (
                <MenuItem key={TransferProtocol[key as any]} value={TransferProtocol[key as any]}>
                    {key.toLowerCase()}
                </MenuItem>
        ))}
 */
export const getEnumKeysAsArray = (en) => {
    return Object.keys(en).filter((key) => !Number.isNaN(Number(en[key])));
};
/**
 * Gets the array of { key: string, value: number } objects.
 * @param en - enum to convert to an array of objects.
 * @returns An array of objects with { key: string, value: number } pair.
 * @example
 * {getEnumAsKeyValuePair(TransferProtocol).map(({ key, value }) => (
                <MenuItem key={value} value={value}>
                    {key.toLowerCase()}
                </MenuItem>
        ))}
 */
export const getEnumAsKeyValuePair = (en) => {
    return Object.keys(en)
        .filter((key) => !Number.isNaN(Number(en[key])))
        .map((key) => ({ key, value: en[key] }));
};
